<template>
  <b-card>
    <b-table
      show-empty
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
    >
      <template v-slot:cell(no)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(action)="data">
        <span>
          <b-button variant="primary" size="sm" @click="onClickView"
            >{{ data.value.view }}EDIT</b-button
          >&nbsp;&nbsp;&nbsp;
          <b-button variant="primary" size="sm"
            >{{ data.value.view }}DELETE</b-button
          >
        </span>
      </template>
    </b-table>
  </b-card>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  },
  methods: {
    onClickBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="css" scoped></style>
